import antd from 'ant-design-vue/es/locale-provider/vi_VN';
import dayjsLocale from 'dayjs/locale/vi';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/vi.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'vi',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
